export const DISMISSED_PATIENT_REQUIRE_INFO_MODAL = '@dismissedPatientRequireInfoModal'
export const PATIENT_HAS_SUCCESSFULLY_UPDATED_INFO = '@patientHasSuccessfullyUpdatedInfo'
export const PATIENT_SCHEDULE_STATUS = '@patient_schedule_status'
export const PATIENT_SAVED_PLAN = '@patientSavedPlan'
export const FILLING_GUIDE_MEDICAL_RECORD = '@fillingGuideMedicalRecord'
export const AUTO_FILLING_GUIDE_MEDICAL_RECORD_ONBOARDING = '@autoFillingGuidMedicalRecordOnboarding'